function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M44 20L44 44H20L44 20Z",
  fill: "#FF5670"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.675 20.2125L29.2875 11.825C28.875 11.275 28.1875 11 27.5 11H16.5C14.9875 11 13.75 12.2375 13.75 13.75V38.5C13.75 40.0125 14.9875 41.25 16.5 41.25H35.75C37.2625 41.25 38.5 40.0125 38.5 38.5V22.1375C38.5 21.45 38.225 20.7625 37.675 20.2125ZM27.5 13.75L35.6125 22H27.5V13.75ZM16.5 38.5V13.75H24.75V22C24.75 23.5125 25.9875 24.75 27.5 24.75H35.75V38.5H16.5Z",
  fill: "#0E185B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.25 24.75H5.5V5.5C5.5 3.9875 6.7375 2.75 8.25 2.75H27.5V5.5H8.25V24.75Z",
  fill: "#FF5670"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  fill: "white"
})));

var SvgCopyFile = function SvgCopyFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy-file.da3fbbd9.svg";
export { ForwardRef as ReactComponent };